import React, { useEffect, useState } from 'react';
import { Storage } from 'aws-amplify';
import { Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import UploadAnnexes from './UploadAnnexes ';
import { makeStyles } from '@material-ui/core/styles';
import PostAddIcon from '@material-ui/icons/PostAdd';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from '../../../constants/constants';
import PdfListFromBundle from './PdfListFromBundle';
import PdfListFromDocument from './PdfListFromDocument';
import PageContentError, { Types } from '../../UI/PageContentError';
import { useTour } from '@reactour/tour';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '80vh',
    [theme.breakpoints.down('md')]: {
      height: 'auto'
    }
  },
  containerScroll: {
    height: '80vh',
    overflowY: 'hide',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      height: 'auto'
    }
  }
}));

const PdfViewer = (props) => {
  const { input, pdfUrl, getData } = props;
  const [document, setDocument] = useState(input);
  const [pdfSignedUrl, setPdfSignedUlr] = useState(null);
  const [ filesName, setFileName ] = useState([]);
  const classes = useStyles();
  const { t } = useTranslation();
  const { setIsOpen } = useTour();

  useEffect(() => {
    if (type === 'bundle') {
      downloadBundleDocumentsFromS3();
    } else if (type) {
      downloadFileFromS3();
    }
  }, []);

  if (!document) {
    const typeNF = props.type || 'template';
    return <PageContentError type={Types.NOT_FOUND} text={t(`error:notFound:${typeNF}NotFound`)} />;
  }
  let { annexes, name, principal, id, status, fileUrl } = document;
  if (!status && document.items && document.items.length > 0) {
    status = document.items[0].status;
  }
  const type = document.type || 'template';

  const downloadFileFromS3 = async () => {
    const urlDocumentMainPdf = await Storage.get(pdfUrl);
    const urlDocumentMainOriginal = await Storage.get(fileUrl);
    let listFilesUrlS3 = [];
    let listNamesFilesS3 = [];
    let urls = [];
    listNamesFilesS3.push(principal ? principal.name : name);
    if (annexes) {
      let arrayPromise = annexes.map((file) => {
        let urlPdf = file.path.replace(/[.]\w{3,4}$/, '.pdf');
        listNamesFilesS3.push(file.name);
        return Storage.get(urlPdf);
      });
      listFilesUrlS3 = await Promise.all(arrayPromise);
      urls = listFilesUrlS3.map((file, i) => ({ url: file, original: annexes[i].path }));
    }
    urls.unshift({ url: urlDocumentMainPdf, original: urlDocumentMainOriginal });
    setFileName(listNamesFilesS3);
    setPdfSignedUlr(urls);
  };

  const downloadBundleDocumentsFromS3 = async () => {
    let listNamesFilesS3 = [];
    let listFilesUrlS3 = [];
    let arrayPromise = input.items.map((document) => {
      let urlPdf = document.fileUrl.replace(/[.]\w{3,4}$/, '.pdf');
      listNamesFilesS3.push(document.name);
      return new Promise(async (resolve) => {
        const url = await Storage.get(urlPdf);
        resolve({ url, original: document.fileUrl });
      });
    });
    listFilesUrlS3 = await Promise.all(arrayPromise);
    setFileName(listNamesFilesS3);
    setPdfSignedUlr(listFilesUrlS3);
  };

  const renderUploadBtn = (i) => {
    if (type === 'document' && status !== CONSTANTS.DOCUMENT.STATUS.INIT) return;
    if (type === 'bundle' && (!(status === CONSTANTS.BUNDLE.STATUS.INIT || status === CONSTANTS.BUNDLE.STATUS.READY))) return;

    let pathname;

    if (type === 'bundle') {
      pathname = `/${type}/update/${input.items[i].id}`;
    } else if (type === 'bundleDocument') {
      pathname = `/document/update/${id}`;
    } else {
      pathname = `/${type}/update/${id}`;
    }

    return (
      <Tooltip disableFocusListener title={t('viewer:uploadNewVersion')}>
        <IconButton
          className='document-uploadNewVersion'
          component={RouterLink}
          onClick={() => setIsOpen(false)}
          to={{ pathname, params: { input: type === 'bundle' ? input.items[i] : input }, type }}
          style={{ color: 'black' }}>
          <PostAddIcon style={{ fontSize: '18px' }} />
        </IconButton>
      </Tooltip>
    );
  };

  const downloadAnnexeFile = (url) => async () => {
    let urlFileS3 = await Storage.get(url);
    window.open(urlFileS3, '_blank');
  };

  const downloadMainDocument = (url) => {
    let urlDocument = '';
    type === 'document' && status !== CONSTANTS.DOCUMENT.STATUS.INIT
      ? urlDocument = url.url
      : urlDocument = url.original;
    return window.open(urlDocument, '_blank');
  };

  const downloadBundleDocument = async (url) => {
    let urlDocument = url.url;
    if (status === CONSTANTS.BUNDLE.STATUS.INIT || status === CONSTANTS.BUNDLE.STATUS.READY) {
      urlDocument = await Storage.get(url.original);
    }
    return window.open(urlDocument, '_blank');
  };

  return (
    <div className={classes.container}>
      <div className={classes.containerScroll}>
        {(type === 'document' || type === 'template' || type === 'bundleDocument') && pdfSignedUrl && <PdfListFromDocument
          pdfSignedUrl={pdfSignedUrl}
          filesName={filesName}
          downloadMainDocument={downloadMainDocument}
          renderUploadBtn={renderUploadBtn}
          downloadAnnexeFile={downloadAnnexeFile}
          input={input}
          getData={getData}
          type={type}
        />}
        {type === 'bundle' && pdfSignedUrl && <PdfListFromBundle
          pdfSignedUrl={pdfSignedUrl}
          downloadBundleDocument={downloadBundleDocument}
          renderUploadBtn={renderUploadBtn}
          input={input}
          filesName={filesName}
        /> }
        <UploadAnnexes annexes={annexes} getData={getData} document={input} setDocument={setDocument} />
      </div>
    </div>
  );
};

PdfViewer.propTypes = {
  annexes: PropTypes.array,
  name: PropTypes.string,
  id: PropTypes.string,
  status: PropTypes.string,
  input: PropTypes.object.isRequired,
  pdfUrl: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]).isRequired,
  getData: PropTypes.func.isRequired
};

export default PdfViewer;
